import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded'
import AccountBox from '@mui/icons-material/AccountBox'
import { PAYMENT_TYPE_ID } from 'constant/paymentType'
import QrCodeIcon from '@mui/icons-material/QrCode'
import GiftCardIcon from '@mui/icons-material/CardGiftcard'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import { PaymentSettingContract } from 'models'

function EvoPaymentLogo({ width = 100 }: { width?: number }) {
    return (
        <img src="/images/evo-logo.png" alt="EVO Payment logo" width={width} />
    )
}
interface MapPaymentIconProp {
    customLogoUrl?: string
    paymentTypeId: number
    size?: number
    color?:
        | 'inherit'
        | 'primary'
        | 'secondary'
        | 'action'
        | 'disabled'
        | 'error'
}

/** Use in POS client and CFD */
export const MapPaymentIcon = (props: MapPaymentIconProp) => {
    const { paymentTypeId, size = 36, color = 'primary' } = props
    if (props.customLogoUrl)
        return <img src={props.customLogoUrl} width={size * 1.45} alt="logo" />
    switch (paymentTypeId) {
        case PAYMENT_TYPE_ID.CASH:
            return (
                <PaymentsRoundedIcon style={{ fontSize: size }} color={color} />
            )
        case PAYMENT_TYPE_ID.CHANNEL_ACCOUNT:
        case PAYMENT_TYPE_ID.CUSTOMER_ACCOUNT:
            return <AccountBox style={{ fontSize: size }} color={color} />
        case PAYMENT_TYPE_ID.PROMPTPAY:
            return <QrCodeIcon style={{ fontSize: size }} color={color} />
        case PAYMENT_TYPE_ID.GIFTCARD:
            return <GiftCardIcon style={{ fontSize: size }} color={color} />
        case PAYMENT_TYPE_ID.CREDITCARD:
            return <CreditCardIcon style={{ fontSize: size }} color={color} />
        case PAYMENT_TYPE_ID.EVO_PAYMENT:
            return <EvoPaymentLogo width={size * 1.45} />
        default:
            return null
    }
}
export const mapPaymentTypeName = (
    paymentTypeId?: number,
    isFromPaymentDialog: boolean = false,
    extra: {
        paymentSetting?: PaymentSettingContract
    } = {},
) => {
    if (!paymentTypeId) return '-'
    if (extra.paymentSetting?.customPaymentTypeID)
        return extra.paymentSetting.name ?? 'custom payment'
    if (paymentTypeId === PAYMENT_TYPE_ID.CASH) return 'Cash'
    if (paymentTypeId === PAYMENT_TYPE_ID.CUSTOMER_ACCOUNT)
        return 'Customer Account'
    if (paymentTypeId === PAYMENT_TYPE_ID.CHANNEL_ACCOUNT)
        return 'Channel Account'
    if (paymentTypeId === PAYMENT_TYPE_ID.PROMPTPAY)
        return 'Prompt Pay' + (isFromPaymentDialog ? ' (Offline)' : '')
    if (paymentTypeId === PAYMENT_TYPE_ID.GIFTCARD) return 'Gift Card'
    if (paymentTypeId === PAYMENT_TYPE_ID.CREDITCARD) return 'Credit Card'
    if (paymentTypeId === PAYMENT_TYPE_ID.EVO_PAYMENT)
        return isFromPaymentDialog ? 'EVO Payment' : 'EVO'
    return '-'
}
